
import { useCallback, useState } from 'react';
import { pay, getPaymentStatus, type PaymentStatus } from '@base-org/account';

interface PayOptions {
    amount: string;
    to: string;
    testnet?: boolean;
    payerInfo?: {
        requests: Array<{ type: 'email' | 'name' | 'phoneNumber' | 'physicalAddress' | 'onchainAddress'; optional?: boolean }>;
        callbackURL?: string;
    };
}

export const useBasePay = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const initiatePayment = useCallback(async ({ amount, to, testnet = false, payerInfo }: PayOptions) => {
        setLoading(true);
        setError(null);
        try {
            const payment = await pay({
                amount,
                to,
                testnet,
                payerInfo
            });
            return payment;
        } catch (err: any) {
            console.error('Payment failed:', err);
            setError(err.message || 'Payment failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    const checkStatus = useCallback(async (id: string, testnet: boolean = false) => {
        try {
            const statusResponse = await getPaymentStatus({ id, testnet });
            return statusResponse;
        } catch (err: any) {
            console.error('Status check failed:', err);
            throw err;
        }
    }, []);

    return {
        initiatePayment,
        checkStatus,
        loading,
        error
    };
};
